import { defineStore } from 'pinia'

import state from './state'
import actions from './actions'

export const useRelated = defineStore('relatedPatient', {
  state,
  actions
})